import api from './api';

const authService = {
  getPublicSettings: () => api.get('/auth/public-settings'),
  checkDomain: (email: string) => api.post('/auth/check-domain', { email }),
  initiateRegistration: (data: { email: string; firstName: string; lastName: string; password: string }) =>
    api.post('/auth/register/initiate', data),
  verifyRegistration: (data: { email: string; code: string }) =>
    api.post('/auth/register/verify', data),
  completeRegistration: (data: { email: string; token: string }) =>
    api.post('/auth/register/complete', data),
  forgotPassword: (email: string) => api.post('/auth/forgot-password', { email }),
  verifyResetCode: (data: { email: string; code: string }) =>
    api.post('/auth/forgot-password/verify', data),
  resetPassword: (data: { email: string; token: string; password: string }) =>
    api.post('/auth/reset-password', data),
  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    api.post('/auth/change-password', data),
  deleteAccount: (confirmation: string) => api.delete('/auth/delete-account', { data: { confirmation } }),
};

export default authService;
